<template>
	<div>
		 <el-tabs v-model="activeName" type="card">
			 <el-tab-pane label="核销券码" name="handleCoupon">
			 	<handleCoupon></handleCoupon>
			 </el-tab-pane>
<!-- 		    <el-tab-pane label="操作订单" name="handleOrder">
				<handleOrder></handleOrder>
			</el-tab-pane> -->
		  </el-tabs>
	</div>
</template>

<script>
	import handleOrder from "./handle/handleOrder.vue"
	import handleCoupon from "./handle/handleCoupon.vue"
	export default {
		components: {
			name:'handle',
			handleOrder,
			handleCoupon
		},
		data() {
			return {
				activeName: 'handleCoupon'
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style>

</style>
